export const loadResourcesLatest = (progressFunction, completeFunction) => {
    let preload = new window.createjs.LoadQueue();

    preload.addEventListener("progress", progressFunction);
    preload.addEventListener("complete", completeFunction);

    preload.loadFile("/images/backgrounds/ol_dt_menu_bg.png");
    preload.loadFile("/images/backgrounds/ol_dt_index_bg.png");
    preload.loadFile("/images/backgrounds/ol_dt_intro_bg.png");
    preload.loadFile("/images/backgrounds/ol_dt_pro_bg-gr.png");
    preload.loadFile("/images/backgrounds/ol_dt_co_bg-gr.jpg");
    preload.loadFile("/images/backgrounds/ol_dt_de_bg.jpg");
    preload.loadFile("/images/backgrounds/ol_dt_contact_bg.jpg");


    preload.loadFile("/videos/loading/ol_loading_00_opening_contact_to_latest.mp4");
    preload.loadFile("/videos/loading/ol_loading_01_latest_to_about.mp4");
    preload.loadFile("/videos/loading/ol_loading_02_latest_to_production.mp4");
    preload.loadFile("/videos/loading/ol_loading_03_latest_to_CoProduction.mp4");
    preload.loadFile("/videos/loading/ol_loading_04_latest_to_department.mp4");
    preload.loadFile("/videos/loading/ol_loading_05_latest_to_contact.mp4");
}

export const loadResourcesAbout = (progressFunction, completeFunction) => {
    let preload = new window.createjs.LoadQueue();

    // preload.addEventListener("progress", progressFunction);
    // preload.addEventListener("complete", completeFunction);

    preload.loadFile("/videos/loading/ol_loading_06_about_to_latest.mp4");
    preload.loadFile("/videos/loading/ol_loading_07_about_to_production.mp4");
    preload.loadFile("/videos/loading/ol_loading_08_about_to_CoProduction.mp4");
    preload.loadFile("/videos/loading/ol_loading_09_about_to_department.mp4");
    preload.loadFile("/videos/loading/ol_loading_10_about_to_contact.mp4");
}

export const loadResourcesProduction = (progressFunction, completeFunction) => {
    let preload = new window.createjs.LoadQueue();

    // preload.addEventListener("progress", progressFunction);
    // preload.addEventListener("complete", completeFunction);

    preload.loadFile("/videos/loading/ol_loading_11_production_to_latest.mp4");
    preload.loadFile("/videos/loading/ol_loading_12_production_to_about.mp4");
    preload.loadFile("/videos/loading/ol_loading_13_production_to_CoProduction.mp4");
    preload.loadFile("/videos/loading/ol_loading_14_production_to_department.mp4");
    preload.loadFile("/videos/loading/ol_loading_15_production_to_contact.mp4");
}

export const loadResourcesCoProduction = (progressFunction, completeFunction) => {
    let preload = new window.createjs.LoadQueue();

    // preload.addEventListener("progress", progressFunction);
    // preload.addEventListener("complete", completeFunction);

    preload.loadFile("/videos/loading/ol_loading_16_coProduction_to_latest.mp4");
    preload.loadFile("/videos/loading/ol_loading_17_coProduction_to_about.mp4");
    preload.loadFile("/videos/loading/ol_loading_18_coProduction_to_production.mp4");
    preload.loadFile("/videos/loading/ol_loading_19_coProduction_to_department.mp4");
    preload.loadFile("/videos/loading/ol_loading_20_coProduction_to_contact.mp4");
}

export const loadResourcesDepartment = (progressFunction, completeFunction) => {
    let preload = new window.createjs.LoadQueue();

    // preload.addEventListener("progress", progressFunction);
    // preload.addEventListener("complete", completeFunction);

    preload.loadFile("/videos/loading/ol_loading_21_department_to_latest.mp4");
    preload.loadFile("/videos/loading/ol_loading_22_department_to_about.mp4");
    preload.loadFile("/videos/loading/ol_loading_23_department_to_production.mp4");
    preload.loadFile("/videos/loading/ol_loading_24_department_to_coProduction.mp4");
    preload.loadFile("/videos/loading/ol_loading_25_department_to_contact.mp4");
}

export const loadResourcesContact = (progressFunction, completeFunction) => {
    let preload = new window.createjs.LoadQueue();

    // preload.addEventListener("progress", progressFunction);
    // preload.addEventListener("complete", completeFunction);

    preload.loadFile("/videos/loading/ol_loading_26_contact_to_about.mp4");
    preload.loadFile("/videos/loading/ol_loading_27_contact_to_production.mp4");
    preload.loadFile("/videos/loading/ol_loading_28_contact_to_coProduction.mp4");
    preload.loadFile("/videos/loading/ol_loading_29_contact_to_department.mp4");
}


export const getBackground = (path, isDesktop) => {
    let backgroundPath = ""
    switch (path) {
        case '/':
            backgroundPath = isDesktop ? "/images/backgrounds/ol_dt_index_bg.png" : "/images/backgrounds/ol_phone_latest.jpg";
            break;
        case '/about':
            backgroundPath = isDesktop ? "/images/backgrounds/ol_dt_intro_bg.png" : "/images/backgrounds/ol_phone_about.jpg";
            break;
        case '/latest':
            backgroundPath = isDesktop ? "/images/backgrounds/ol_dt_index_bg.png" : "/images/backgrounds/ol_phone_latest.jpg";
            break;
        case '/production_list':
        case '/production':
        case (path.match(/\/production/) || {}).input:
            backgroundPath = isDesktop ? "/images/backgrounds/ol_dt_pro_bg-gr.png" : "/images/backgrounds/ol_phone_production.jpg";
            break;
        case '/co_production':
        case (path.match(/\/co_production/) || {}).input:
            backgroundPath = isDesktop ? "/images/backgrounds/ol_dt_co_bg-gr.jpg" : "/images/backgrounds/ol_phone_co-production.jpg";
            break;
        case '/department':
        case (path.match(/\/department/) || {}).input:
            backgroundPath = isDesktop ? "/images/backgrounds/ol_dt_de_bg.jpg" : "/images/backgrounds/ol_phone_department.jpg";
            break;
        case '/contact':
            backgroundPath = isDesktop ? "/images/backgrounds/ol_dt_contact_bg.jpg" : "/images/backgrounds/ol_phone_contact.jpg";
            break;
    }
    return backgroundPath;
}

export const getCutSceneVideo = (prevPath, currentPath) => {
    let videoPath = "";
    switch (prevPath) {
        case '/':
            switch (currentPath) {
                case '/':
                    videoPath = "/videos/loading/ol_loading_00_opening_contact_to_latest.mp4";
                    break;
                case '/about':
                    videoPath = "/videos/loading/ol_loading_01_latest_to_about.mp4";
                    break;
                case '/production_list':
                case (currentPath.match(/\/production/) || {}).input:
                    videoPath = "/videos/loading/ol_loading_02_latest_to_production.mp4";
                    break;
                case '/co_production':
                    videoPath = "/videos/loading/ol_loading_03_latest_to_CoProduction.mp4";
                    break;
                case '/department':
                    videoPath = "/videos/loading/ol_loading_04_latest_to_department.mp4";
                    break;
                case '/contact':
                    videoPath = "/videos/loading/ol_loading_05_latest_to_contact.mp4";
                    break;
            }
        case '/latest':
            switch (currentPath) {
                case '/about':
                    videoPath = "/videos/loading/ol_loading_01_latest_to_about.mp4";
                    break;
                case '/production_list':
                case (currentPath.match(/\/production/) || {}).input:
                    videoPath = "/videos/loading/ol_loading_02_latest_to_production.mp4";
                    break;
                case '/co_production':
                    videoPath = "/videos/loading/ol_loading_03_latest_to_CoProduction.mp4";
                    break;
                case '/department':
                    videoPath = "/videos/loading/ol_loading_04_latest_to_department.mp4";
                    break;
                case '/contact':
                    videoPath = "/videos/loading/ol_loading_05_latest_to_contact.mp4";
                    break;
            }
            break;
        case '/about':
            switch (currentPath) {
                case '/latest':
                    videoPath = "/videos/loading/ol_loading_06_about_to_latest.mp4";
                    break;
                case '/production_list':
                case (currentPath.match(/\/production/) || {}).input:
                    videoPath = "/videos/loading/ol_loading_07_about_to_production.mp4";
                    break;
                case '/co_production':
                    videoPath = "/videos/loading/ol_loading_08_about_to_CoProduction.mp4";
                    break;
                case '/department':
                    videoPath = "/videos/loading/ol_loading_09_about_to_department.mp4";
                    break;
                case '/contact':
                    videoPath = "/videos/loading/ol_loading_10_about_to_contact.mp4";
                    break;
            }
            break;
        case '/production_list':
            switch (currentPath) {
                case '/latest':
                    videoPath = "/videos/loading/ol_loading_11_production_to_latest.mp4";
                    break;
                case '/about':
                    videoPath = "/videos/loading/ol_loading_12_production_to_about.mp4";
                    break;
                case '/co_production':
                    videoPath = "/videos/loading/ol_loading_13_production_to_CoProduction.mp4";
                    break;
                case '/department':
                    videoPath = "/videos/loading/ol_loading_14_production_to_department.mp4";
                    break;
                case '/contact':
                    videoPath = "/videos/loading/ol_loading_15_production_to_contact.mp4";
                    break;
            }
            break;
        case '/production':
        case (prevPath.match(/\/production/) || {}).input:
            switch (currentPath) {
                case '/latest':
                    videoPath = "/videos/loading/ol_loading_11_production_to_latest.mp4";
                    break;
                case '/about':
                    videoPath = "/videos/loading/ol_loading_12_production_to_about.mp4";
                    break;
                case '/co_production':
                    videoPath = "/videos/loading/ol_loading_13_production_to_CoProduction.mp4";
                    break;
                case '/department':
                    videoPath = "/videos/loading/ol_loading_14_production_to_department.mp4";
                    break;
                case '/contact':
                    videoPath = "/videos/loading/ol_loading_15_production_to_contact.mp4";
                    break;
            }
            break;
        case '/co_production':
        case (prevPath.match(/\/co_production/) || {}).input:
            switch (currentPath) {
                case '/latest':
                    videoPath = "/videos/loading/ol_loading_16_coProduction_to_latest.mp4";
                    break;
                case '/about':
                    videoPath = "/videos/loading/ol_loading_17_coProduction_to_about.mp4";
                    break;
                case '/production_list':
                case (currentPath.match(/\/production/) || {}).input:
                    videoPath = "/videos/loading/ol_loading_18_coProduction_to_production.mp4";
                    break;
                case '/department':
                    videoPath = "/videos/loading/ol_loading_19_coProduction_to_department.mp4";
                    break;
                case '/contact':
                    videoPath = "/videos/loading/ol_loading_20_coProduction_to_contact.mp4";
                    break;
            }
            break;
        case '/department':
        case (prevPath.match(/\/department/) || {}).input:
            switch (currentPath) {
                case '/latest':
                    videoPath = "/videos/loading/ol_loading_21_department_to_latest.mp4";
                    break;
                case '/about':
                    videoPath = "/videos/loading/ol_loading_22_department_to_about.mp4";
                    break;
                case '/production_list':
                case (currentPath.match(/\/production/) || {}).input:
                    videoPath = "/videos/loading/ol_loading_23_department_to_production.mp4";
                    break;
                case '/co_production':
                    videoPath = "/videos/loading/ol_loading_24_department_to_coProduction.mp4";
                    break;
                case '/contact':
                    videoPath = "/videos/loading/ol_loading_25_department_to_contact.mp4";
                    break;
            }
            break;
        case '/contact':
            switch (currentPath) {
                case '/latest':
                    videoPath = "/videos/loading/";
                    break;
                case '/about':
                    videoPath = "/videos/loading/ol_loading_26_contact_to_about.mp4";
                    break;
                case '/production_list':
                case (currentPath.match(/\/production/) || {}).input:
                    videoPath = "/videos/loading/ol_loading_27_contact_to_production.mp4";
                    break;
                case '/co_production':
                    videoPath = "/videos/loading/ol_loading_28_contact_to_coProduction.mp4";
                    break;
                case '/department':
                    videoPath = "/videos/loading/ol_loading_29_contact_to_department.mp4";
                    break;
            }
            break;
    }
    return videoPath;
}